import certified_en from "../../../assets/images/certified_en.png";
import certified_ar from "../../../assets/images/certified_ar.png";
import { Link, useHistory } from "react-router-dom";
import { Heart, HeartFilled, Minus } from "../../Icons";
import { FormatPrice, FormatUnit } from "../../../utils/generalUtils";
import style from "./index.module.css";
import { MouseEventHandler, useCallback } from "react";
import cardStyle from "../SingleVehicleCard/index.module.css";
import noImagePlaceholder from "../../../assets/images/romotors-no-image-available-notext.jpg";
import { useTranslation } from "../../../hooks/useTranslation";
import { useSelector } from "react-redux";
import { selectUser } from "../../../store/userSlice";

const SingleUsedVehicleCard = ({
  link,
  image,
  showroom,
  location,
  date,
  name,
  mileage,
  price,
  phone,
  note,
  category,
  isWishlistPage = false,
  removeWishList,
  isMyVehiclesPage = false,
  myVehicleEditLink,
  myVehicleDeleteCb,
  isFeatured,
  ...wishlistProps
}: ComponentPropsType) => {
  const { locale, siteLang } = useTranslation();
  const { user } = useSelector(selectUser);
  const history = useHistory();
  const isFeaturedNormalized = isFeatured ?? false;

  return (
    <div className={cardStyle.vehicle}>
      <div className={style.vehicle_image}>
        <Link to={link}>
          <img src={image || noImagePlaceholder} alt="" />
        </Link>
        {showroom.is_showroom ? (
          <div className={style.vehicle_showroom}>
            <Link to={showroom.link as string}>
              <img src={showroom.image} alt="" />
            </Link>
          </div>
        ) : null}
        {wishlistProps.isWishlist !== undefined && !isFeatured ? (
          <button className={style.vehicle_wishlist_heart} onClick={wishlistProps.onToggleWishlist}>
            {wishlistProps.isWishlist ? (
              <HeartFilled height="20" width="20" color="#dc0000" />
            ) : (
              <Heart height="20" width="20" color="#dc0000" />
            )}
          </button>
        ) : null}
        <div className={style.vehicle__location}>
          <span>{location}</span>
          <span>{category?.name}</span>
        </div>
        {isFeatured ? (
          <div className={style.vehicle_certified}>
            <img src={siteLang === "ar" ? certified_ar : certified_en} alt="" />
          </div>
        ) : null}
        {(isWishlistPage && removeWishList) || (isMyVehiclesPage && myVehicleEditLink) ? (
          <button
            className={style.vehicle_unwishlist}
            title={isWishlistPage ? locale("remove_wishlist") : locale("view_my_vehicle")}
            onClick={(e) =>
              myVehicleEditLink ? history.push(myVehicleEditLink) : removeWishList ? removeWishList(e) : {}
            }
          >
            {isWishlistPage ? <Minus width="20" height="20" color="#dc0000" /> : locale("edit")}
          </button>
        ) : null}
        {isMyVehiclesPage && myVehicleDeleteCb ? (
          <button
            className={style.vehicle_unwishlist}
            onClick={() => myVehicleDeleteCb()}
            style={{
              top: "auto",
              width: "48px",
              height: "48px",
              bottom: "5px",
              paddingBottom: "5px",
              transform: "translate(-50%,50%)",
            }}
          >
            {locale("remove")}
          </button>
        ) : null}
      </div>
      <div className={cardStyle.vehicle_details}>
        <div className={cardStyle.vehicle_details__col}>
          <Link to={link}>
            {/* <p>
              {isFeatured ? <span className={style.vehicle_details__badge}>{locale("sponsared")}</span> : null}
              <b
                style={{
                  color: isFeaturedNormalized ? "#dc0000" : "#000",
                  fontWeight: isFeaturedNormalized ? "800" : "500",
                }}
              >
                {name}
              </b>
            </p> */}
            <p>
              <b>{name}</b>
            </p>
            {mileage ? (
              <p className={style.vehicle_details__km}>
                <FormatUnit value={mileage} unit="kilometer" />
              </p>
            ) : null}
          </Link>
        </div>
        <div className={cardStyle.vehicle_details__col}>
          {+price === 0 ? (
            phone ? (
              <a href={`tel:${phone}`}>{locale("callForPrice")}</a>
            ) : (
              locale("currentlyUnavailableNewVehicle")
            )
          ) : (
            <p className={cardStyle.price}>
              <FormatPrice value={price} />
            </p>
          )}
          {note ? (
            <p className={style.vehicle_details__note}>{note}</p>
          ) : // <p className={style.vehicle_details__note}>
          //   {locale("price")}
          // </p>
          null}
        </div>
      </div>
    </div>
  );
};

export default SingleUsedVehicleCard;

type ComponentPropsType = {
  image: string;
  link: string;
  location: string;
  date: string;
  name: string;
  mileage?: number;
  price: string;
  phone?: string;
  showroom: {
    is_showroom: boolean;
    image?: string;
    link?: string;
  };
  note?: string;
  category?: {
    name: string;
    icon: string;
  };
  isWishlistPage?: boolean;
  removeWishList?: MouseEventHandler<HTMLButtonElement>;
  isMyVehiclesPage?: boolean;
  myVehicleEditLink?: string;
  myVehicleDeleteCb?: CallableFunction;
  /**
   * indicate if the vehicle is featured in the database
   */
  isFeatured?: boolean;
} & (
  | {
      /**
       * if provided, the component will show the wishlist icon and handle the wishlist toggle,
       * if not provided, the component will not show the wishlist icon and will not handle the wishlist toggle
       *
       */
      isWishlist: boolean;
      onToggleWishlist: MouseEventHandler<HTMLButtonElement>;
    }
  | {
      isWishlist?: undefined;
    }
);
